const bordersVars = {
    '--GW-BORDER-COLOR': 'var(--NFUM-COLOR-GREY)',
    '--GW-BORDER-WIDTH-THIN': '0.0625rem', // 2px
    '--GW-BORDER-RADIUS': '0px',
};

export default bordersVars;
